import { IntegrationsSummaryResponse, IntegrationsService } from '@api';
import { selector } from 'recoil';

export const CatalogStatusesState = selector<IntegrationsSummaryResponse>({
  key: 'CatalogStatuses',
  get: async () => IntegrationsService.getSummary(),
});
